import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSizeMSmall = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	viewBox: "0 0 35.173 26.38",
	fill: "currentColor",
	stroke: "currentColor",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "M-S_Banner",
		transform: "translate(6680 21323)",
		children: [/* @__PURE__ */ _jsx("g", {
			id: "Group_177",
			"data-name": "Group 177",
			transform: "translate(-6680 -21323)",
			children: /* @__PURE__ */ _jsx("path", {
				id: "Path_204",
				"data-name": "Path 204",
				d: "M32.242,4.466a1.385,1.385,0,0,1,1.466,1.466V26.449a1.385,1.385,0,0,1-1.466,1.466H2.931a1.385,1.385,0,0,1-1.466-1.466V5.931A1.385,1.385,0,0,1,2.931,4.466H32.242m0-1.466H2.931A2.94,2.94,0,0,0,0,5.931V26.449A2.94,2.94,0,0,0,2.931,29.38H32.242a2.94,2.94,0,0,0,2.931-2.931V5.931A2.94,2.94,0,0,0,32.242,3Z",
				transform: "translate(0 -3)"
			})
		}), /* @__PURE__ */ _jsx("path", {
			id: "Path_2708",
			"data-name": "Path 2708",
			d: "M3.784-7.82,6.728.492,9.656-7.82h3.1V3.641H10.388V.508L10.624-4.9,7.531,3.641H5.909L2.824-4.892,3.06.508V3.641H.7V-7.82Z",
			transform: "translate(-6669.122 -21307.672)"
		})]
	})
});
export default SvgSizeMSmall;
